<template>
  <div>
    <b-modal
      id="edit-product"
      size="lg modal-xlg"
      title="Edit Product"
      hide-footer
      ref="EditProduct"
      no-close-on-backdrop
      no-close-on-esc
      @show="onShowModal"
      @hide="closeModal"
    >
      <b-container fluid class="px-0">
        <div class="modal-form">
          <b-row no-gutters>
            <b-col
              class="border-top border-right add-delivery-sidebar bg-white"
              lg="3"
            >
              <BasicDetails
                v-if="branches.length"
                :values="basic_details"
                :origin="'edit_product'"
              />

              <template v-if="basic_details.product_variation == 'variable'">
                <Variables
                  :values="product_variables"
                  @addAttribute="addAttribute"
                  @addVariation="addVariation"
                  @generateVariations="generateVariations"
                  @deleteVariation="deleteVariation"
                  @deleteAttribute="deleteAttribute"
                  :origin="'edit_product'"
                />
              </template>
              <AdOns
                :values="ad_on_items"
                @addAttributeAdOn="addAttributeAdOn"
                @addVariationAdOn="addVariationAdOn"
                @generateVariationsAdOn="generateVariationsAdOn"
                @addAttributeAdOnEdit="addAttributeAdOnEdit"
                @addVariationAdOnEdit="addVariationAdOnEdit"
                @generateVariationsAdOnEdit="generateVariationsAdOnEdit"
                @deleteVariationAdOn="deleteVariationAdOn"
                @deleteVariationAdOnEdit="deleteVariationAdOnEdit"
                @deleteAttributeAdOn="deleteAttributeAdOn"
                @deleteAttributeAdOnEdit="deleteAttributeAdOnEdit"
                :origin="'edit_product'"
              />
              <ProductImages
                :values="product_images"
                @removeImage="removeProductImage"
                :origin="'edit_product'"
              />
            </b-col>
            <b-col class="border-top p-0 position-relative" lg="9">
              <b-row
                no-gutters
                class="border-bottom px-4 py-3"
                style="background-color: #ffffff"
              >
                <b-col></b-col>
                <b-col cols="2">
                  <b-button
                    variant="ghost"
                    block
                    class="delete-button text-uppercase text-secondary"
                    :disabled="loading"
                    @click="toggleConfirmDelete(true)"
                    v-if="!editingFromLocationsPage"
                  >
                    Delete Product
                  </b-button>
                </b-col>
                <b-col cols="2">
                  <b-button
                    variant="primary"
                    v-bind:disabled="loading"
                    block
                    class="save-button"
                    @click="handleSaveProduct"
                  >
                    <template v-if="loading"> SAVING PRODUCT </template>
                    <template v-else> SAVE PRODUCT </template>
                  </b-button>
                </b-col>
              </b-row>
              <div class="main">
                <template v-if="basic_details.product_variation === 'simple'">
                  <SimpleProduct
                    :values="simple_product"
                    :origin="'edit_product'"
                    :payment="payment"
                  />
                </template>
                <template v-else>
                  <ProductVariables
                    :values="variation_items"
                    :discount="product_variables.discount"
                    :origin="'edit_product'"
                    :sale="product_variables.sale"
                    @updateDiscountValue="updateDiscountValue"
                    :variation_names="$parent.variation_names"
                    :payment="payment"
                    :basic_details="basic_details"
                  />
                </template>
                <template v-if="ad_on_items.length > 0">
                  <AdOnItems
                    :generatedAdOns="generatedAdOns"
                    :values="ad_on_items"
                    :origin="'edit_product'"
                    :payment="payment"
                    @updateDiscountValue="updateDiscountValue"
                    @deleteVariationAdOn="deleteVariationAdOn"
                    @deleteVariationAdOnEdit="deleteVariationAdOnEdit"
                    @deleteAttributeAdOn="deleteAttributeAdOn"
                    @deleteAttributeAdOnEdit="deleteAttributeAdOnEdit"
                  />
                </template>
              </div>
              <b-alert
                :show="showConfirmDelete"
                variant="primary"
                class="confirm-delete-product-container position-absolute rounded-0 w-100 border-0 text-white d-flex align-items-center justify-content-between"
                ref="confirm-delete-prompt"
              >
                {{ deletePromptMessage }}
                <div class="confirm-delete-actions-container">
                  <b-button
                    variant="ghost"
                    class="cancel-button text-white shadow-none mr-2"
                    :disabled="loading"
                    @click="toggleConfirmDelete(false)"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    variant="primary"
                    class="save-button px-4 py-2"
                    :disabled="loading"
                    @click="handleConfirmDeleteProduct"
                  >
                    {{ loading ? "Deleting..." : "Yes" }}
                  </b-button>
                </div>
              </b-alert>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <template slot="modal-header-close">
        <span @click="closeModal">×</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

import BasicDetails from "./BasicDetails";
import ProductImages from "./ProductImages";
import SimpleProduct from "./SimpleProduct";
import ProductVariables from "./ProductVariables";
import Variables from "./Variables";
import AdOns from "./AdOns";
import AdOnItems from "./AdOnItems";
import pvg from "@/services/product.variance.generator";
import _ from "lodash";

function initialProductImages() {
  return [
    { image: "", active: false },
    { image: "", active: false },
    { image: "", active: false },
    { image: "", active: false },
    { image: "", active: false },
    { image: "", active: false },
    { image: "", active: false },
    { image: "", active: false },
    { image: "", active: false },
    { image: "", active: false },
  ];
}

export default {
  name: "EditProduct",
  props: [
    "status",
    "basic_details",
    "simple_product",
    "product_variables",
    "variation_items",
    "payment",
    "from_page",
    "ad_ons",
  ],
  components: {
    BasicDetails,
    ProductImages,
    SimpleProduct,
    ProductVariables,
    Variables,
    AdOns,
    AdOnItems,
  },
  data() {
    return {
      uuid: null,
      product_images: initialProductImages(),
      variation_names: [],
      delete_images: [],
      init_daterange: [],
      ad_on_items: [],
      temporary_ad_on_items: [],
      generatedAdOns: false,
      showConfirmDelete: false,
      deleteVariableProduct: {
        status: false,
        uuid: null,
      },
      old_variations: [],
      isUpdated: false,
    };
  },
  computed: {
    ...mapState("estoreInventories", [
      "loading",
      "errors",
      "product_data",
      "modal",
      "sale",
      "pagination",
    ]),
    ...mapState("estoreLocations", {
      estoreLocationsModal: (state) => state.modal,
      editingFromLocationsPage: (state) => state.editingFromLocationsPage,
      branchInfo: (state) => state.branchInfo,
    }),
    ...mapState("analytics", ["isSegmentAnalyticsReady"]),
    ...mapState("branches", ["branches"]),
    ...mapGetters({
      merchantDetails: "auth/merchantDetails",
    }),
    isTierZero: {
      get() {
        return this.merchantDetails.plan_details.code === "tier_0";
      },
      set(isTierZero) {
        return isTierZero;
      },
    },
    hasTagged() {
      if (_.has(this.product_data, "branch_uuids"))
        return this.product_data.branch_uuids.length > 0;
      else return false;
    },
    deletePromptMessage() {
      if (this.hasTagged)
        return "This product is currently tagged to a brand and branch. Are you sure you want to delete this?";
      else return "Are you sure you want to delete this?";
    },
  },
  mounted() {
    this.$root.$on("editDeleteVariableProduct", (uuid) => {
      this.toggleConfirmDelete(true);
      this.deleteVariableProduct = {
        status: true,
        uuid: uuid,
      };
    });
  },
  beforeDestroy() {
    this.$root.$off("editDeleteVariableProduct");
  },
  methods: {
    ...mapMutations({
      setErrors: "estoreInventories/errors",
    }),
    ...mapActions({
      deleteProduct: "estoreInventories/deleteProduct",
      productDelete: "estoreInventories/productDelete",
      getCategories: "estoreInventories/getCategories",
    }),
    onShowModal() {
      this.$root.$emit("clearSelectedBrandsAndBranches");
    },
    closeModal: function () {
      this.showConfirmDelete = false;

      this.setInitialData();
      if (this.from_page == "locations-products") {
        this.$store.commit("estoreLocations/setModal", {
          type: "edit_product",
          status: false,
        });
        this.$store.commit(
          "estoreLocations/setEditingFromLocationsPage",
          false
        );
      } else {
        this.$store.commit("estoreInventories/setModal", {
          type: "edit_product",
          status: false,
        });
      }
    },
    handleSaveProduct() {
      const product_type = this.basic_details.product_variation;
      const is_images_empty =
        this.product_images.map((item) => item.image).filter((image) => image)
          .length === 0;
      const errors = {
        errors: {},
      };

      if (is_images_empty)
        errors.errors["product_images"] = "Product images is required.";

      if (
        product_type === "variable" &&
        this.product_variables.attributes.length === 0
      )
        errors.errors["product_attributes"] = "Product attributes is required.";

      this.$nextTick(() => {
        this.setErrors(errors);
        if (Object.keys(errors.errors).length === 0) this.saveProduct();
      });
    },
    saveProduct: async function () {
      let update_images = await this.product_images
        .map((image) => {
          return {
            action: "create",
            image: image.image.split("base64,").pop(),
          };
        })
        .filter((image) => image.image !== "")
        .filter((image) => image.image.split(":")[0] !== "https");

      if (this.delete_images.length > 0) {
        this.delete_images.map((image) => {
          return update_images.push(image);
        });
      }

      let check_images = this.product_images
        .map((image) => {
          return image;
        })
        .filter((image) => image.image !== "");

      let param = {
        uuid: this.uuid,
        updates: {},
      };

      let formattedAdOns = [];
      this.ad_on_items.forEach((attribute) => {
        let formattedAttribute = {};
        formattedAttribute = {
          uuid: attribute.uuid,
          name: attribute.name,
          limit: attribute.limit,
          items: attribute.add_ons,
        };
        formattedAdOns.push(formattedAttribute);
      });

      param.updates["add_ons"] = formattedAdOns;

      let basic_details = this.basic_details;

      param.updates["name"] = basic_details.name;
      param.updates["description"] = basic_details.description;
      param.updates["category_id"] = basic_details.category_id;
      param.updates["branch_uuids"] = basic_details.selected_all_brands_branches
        ? []
        : basic_details.branch_uuids;

      if (this.branches.length === 1)
        param.updates["branch_uuids"] = [this.branches[0].uuid];

      param.updates["selected_all_brands_branches"] =
        basic_details.selected_all_brands_branches;

      if (update_images.length > 0 || check_images.length == 0) {
        param.updates["product_images"] = update_images;
      }

      let simple_product = this.simple_product;

      param.updates["on_sale"] = simple_product.on_sale;
      param.updates["visibility"] = simple_product.visibility;
      param.updates["stock"] = simple_product.stock;
      param.updates["is_limited_stock"] = simple_product.is_limited_stock;
      param.updates["currency"] = simple_product.currency;
      param.updates["regular_price"] = simple_product.regular_price;
      param.updates["sku"] = simple_product.sku;

      if (simple_product.on_sale == true || simple_product == 1) {
        param.updates["discount_type"] = simple_product.discount_type;
        param.updates["discount_value"] = simple_product.discount_value;

        if (this.$parent.isMoment(simple_product.date_range.split(" to ")[0])) {
          param.updates["on_sale_from"] =
            simple_product.date_range.split(" to ")[0] + " 00:00:00";
        } else {
          param.updates["on_sale_from"] =
            this.$parent.formatDate(
              simple_product.date_range.split(" to ")[0]
            ) + " 00:00:00";
        }
        if (this.$parent.isMoment(simple_product.date_range.split(" to ")[1])) {
          param.updates["on_sale_from"] =
            simple_product.date_range.split(" to ")[1] + " 23:59:59";
        } else {
          param.updates["on_sale_to"] =
            this.$parent.formatDate(
              simple_product.date_range.split(" to ")[1]
            ) + " 23:59:59";
        }
      }

      if (this.from_page == "locations-products") {
        param.branch_uuid = this.branchInfo.uuid;
      }

      if (basic_details.product_variation === "simple") {
        await this.$store
          .dispatch("estoreInventories/updateSimpleProduct", param)
          .then(() => {
            if (this.errors == null) {
              this.getCategories();
              this.closeModal();

              if (this.isSegmentAnalyticsReady) {
                param.updates.product_images = !!(
                  param.updates.product_images &&
                  param.updates.product_images.length
                );

                window.analytics.track("Update E-Store Simple Product", param);
              }

              if (this.from_page == "locations-products") {
                this.$store.commit("estoreLocations/setModal", {
                  type: "edit_product",
                  status: false,
                });
                this.$store.commit(
                  "estoreLocations/setEditingFromLocationsPage",
                  false
                );
                this.$parent.getListProductInventoryByBranchAfterUpdate();
              } else {
                this.$store.dispatch("estoreInventories/getProducts", {
                  page: this.pagination.currentPage,
                  payload: {
                    filters: {
                      paired_key: "all",
                      keyword: "",
                      column: "all",
                    },
                  },
                });
              }
            }
          });
      } else {
        param.updates["action"] = "update";
        param.updates["product_variables"] = [];
        param.updates["deleted_variations"] = [];
        param.updates["product_attributes"] = this.product_data.attributes.map(
          (attribute, attributeIndex) => {
            return {
              action: "update",
              name: this.product_variables.attributes[attributeIndex].name,
              uuid: attribute.uuid,
              variations: attribute.variations.map((variant, variantIndex) => {
                return {
                  action: "update",
                  name: this.product_variables.attributes[attributeIndex]
                    .variations[variantIndex].name,
                  hash: variant.hash,
                };
              }),
            };
          }
        );

        let new_attributes = [];

        new_attributes = this.product_variables.attributes
          // .map((attribute, index) => {
          //     return attribute.variations;
          // })
          .map((variant) => {
            // variant.filter(
            //     item => item.action == "create" && item.name !== ""
            // )
            if (variant.action == "create" && variant.name !== "") {
              let variations = [];

              variant.variations.forEach((e) => {
                variations.push({
                  action: "create",
                  hash: e.hash,
                  name: e.name,
                });
              });

              return {
                action: "create",
                name: variant.name,
                variations: variations,
              };
            } else {
              return [];
            }
          });

        new_attributes = new_attributes.filter((item) => item.length != 0);
        new_attributes.map((attribute, index) => {
          if (attribute.length > 0) {
            attribute.map((attribute) => {
              param.updates["product_attributes"][index].variations.push(
                attribute
              );
            });
          }
        });

        new_attributes.forEach((item) => {
          param.updates["product_attributes"].push(item);
        });

        let variations = this.variation_items;

        param.updates["product_variables"] = variations.map((variant) => {
          let variable = {
            action: variant.action,
            variable: {
              uuid: variant.uuid,
              stock: variant.stock,
              currency: variant.currency,
              visibility: variant.visibility,
              sku: variant.sku,
              is_limited_stock: variant.is_limited_stock,
              regular_price: variant.regular_price,
              on_sale: variant.on_sale == 1 ? true : false,
            },
          };
          if (variant.variation_code == null) {
            let variationCode = "";
            let variants = variant.variation.split(" - ");
            for (let index = 0; index < variants.length; index++) {
              for (
                let k = 0;
                k < param.updates["product_attributes"].length;
                k++
              ) {
                let searchResult = param.updates["product_attributes"][
                  k
                ].variations.find(
                  (paramVariation) => paramVariation.name === variants[index]
                );
                if (typeof searchResult !== "undefined") {
                  variationCode += searchResult.hash + "_";
                }
              }
            }
            variable.variable["variation_code"] = variationCode.slice(0, -1);
          } else {
            variable.variable["variation_code"] = variant.variation_code;
          }
          if (variant.on_sale == true || variant.on_sale == 1) {
            variable.variable["discount_type"] = variant.discount_type;
            variable.variable["discount_value"] = variant.discount_value;
            variable.variable["on_sale_from"] =
              variant.date_range !== null
                ? variant.date_range.split(" to ")[0] + " 00:00:00"
                : this.$parent.formatDate(new Date()) + " 00:00:00";
            variable.variable["on_sale_to"] =
              variant.date_range !== null
                ? variant.date_range.split(" to ")[1] + " 23:59:59"
                : this.$parent.formatDate(new Date()) + " 23:59:59";
          }

          return variable;
        });

        this.old_variations.forEach((variation) => {
          try {
            let filtered = param.updates.product_variables.filter(
              (variable) => {
                return (
                  (variable.action == "update" ||
                    variable.action == "create") &&
                  variable.variable.variation_code == variation.variation_code
                );
              }
            );

            if (filtered.length == 0) {
              param.updates["deleted_variations"].push({
                action: "delete",
                variation_code: variation.variation_code,
                uuid: variation.uuid,
              });
            }
          } catch (error) {
            console.log(error);
          }
        });

        await this.$store
          .dispatch("estoreInventories/updateVariableProduct", param)
          .then(() => {
            if (this.errors == null) {
              this.getCategories();
              this.$store.commit("estoreInventories/setModal", {
                type: "edit_product",
                status: false,
              });

              if (this.isSegmentAnalyticsReady) {
                param.updates.product_images = !!_.get(
                  param,
                  "updates.product_images.length",
                  0
                );

                window.analytics.track(
                  "Update E-Store Variable Product",
                  param
                );
              }

              if (this.from_page == "locations-products") {
                this.$store.commit("estoreLocations/setModal", {
                  type: "edit_product",
                  status: false,
                });
                this.$store.commit(
                  "estoreLocations/setEditingFromLocationsPage",
                  false
                );
                this.$parent.getListProductInventoryByBranchAfterUpdate();
              } else {
                this.setInitialData();
                this.$store.dispatch("estoreInventories/getProducts", {
                  page: this.pagination.currentPage,
                  payload: {
                    filters: {
                      paired_key: "all",
                      keyword: "",
                      column: "all",
                    },
                  },
                });
              }
            }
          });
      }
    },
    removeProductImage: async function (image) {
      this.product_images.splice(image.index, 1);
      this.product_images.push({
        image: "",
        active: false,
      });

      let is_images_empty = await this.product_images
        .map((image) => {
          return image;
        })
        .filter((image) => image.image == "");

      this.delete_images.push({
        action: "delete",
        uuid: image.uuid,
      });

      if (is_images_empty.length == 10) {
        await this.$store.commit("estoreInventories/setActiveImage", null);
      } else {
        await this.$store.commit("estoreInventories/setActiveImage", 0);
      }
    },
    addAttribute: function (attribute) {
      this.$parent.addAttribute(attribute);
    },
    addVariation: function (index) {
      this.$parent.addVariation(index);
    },
    generateVariations: function (origin) {
      this.$parent.generateVariations(origin);
    },
    deleteAttribute: function (index) {
      this.$parent.deleteAttribute(index);
    },
    deleteVariation: function (param) {
      this.$parent.deleteVariation(param);
    },
    addAttributeAdOn: function (attribute) {
      this.$parent.addAttributeAdOn(attribute);
    },
    addAttributeAdOnEdit: function (attribute) {
      this.ad_on_items.push(attribute);
      this.generatedAdOns = false;
    },
    addVariationAdOn: function (index) {
      this.$parent.addVariationAdOn(index);
    },
    addVariationAdOnEdit: function (index) {
      this.ad_on_items[index]["add_ons"].push({
        uuid: null,
        action: "create",
        name: "",
        currency: "PHP",
        price: "1",
        sku: null,
        visibility: 1,
        free: 0,
      });
      this.generatedAdOns = false;
    },
    generateVariationsAdOn: function () {
      this.$parent.generateVariationsAdOn();
    },
    generateVariationsAdOnEdit: function () {
      let known_variants = new Set();
      this.ad_on_items.map((product) => {
        product.add_ons = product.add_ons.filter(
          (item) =>
            !known_variants.has(item.name.toLowerCase()) &&
            known_variants.add(item.name.toLowerCase()) &&
            item.name != ""
        );
        return product;
      });

      this.ad_on_items = this.ad_on_items.filter(
        (product) => product.name != ""
      );

      this.generatedAdOns = true;
    },
    deleteAttributeAdOn: function (index) {
      this.$parent.deleteAttributeAdOn(index);
    },
    deleteAttributeAdOnEdit: function (index) {
      this.ad_on_items.splice(index, 1);
    },
    deleteVariationAdOn: function (param) {
      this.$parent.deleteVariationAdOn(param);
    },
    deleteVariationAdOnEdit: function (param) {
      this.ad_on_items[param.attribute].add_ons.splice(param.variation, 1);
    },
    updateDiscountValue: function (value) {
      this.$parent.updateDiscountValue(value);
    },
    setInitialData: function () {
      this.$parent.setBasicDetailsInit();
      this.$parent.setSimpleProductInit();
      this.$parent.setProductVariablesInit();
      this.$parent.setVariationItemsInit();
      this.product_images = initialProductImages();
    },
    toggleConfirmDelete(value) {
      this.showConfirmDelete = value;
      this.$nextTick(() => {
        if (value)
          this.$refs["confirm-delete-prompt"].$el.scrollIntoView({
            behavior: "smooth",
          });
      });
    },
    async handleDeleteProduct(data) {
      const param = {
        uuid: data.uuid,
      };
      await this.deleteProduct(param);
      this.$store.dispatch("estoreInventories/getProduct", {
        uuid: this.product_data.uuid,
        type: data.type,
      });
      this.deleteVariableProduct = {
        status: false,
        uuid: null,
      };
      this.showConfirmDelete = false;
    },
    async handleConfirmDeleteProduct() {
      const product_type = this.basic_details.product_variation;
      if (this.deleteVariableProduct.status) {
        this.handleDeleteProduct({
          uuid: this.deleteVariableProduct.uuid,
          type: product_type,
        });
      } else {
        const param = {
          product_id:
            product_type == "simple"
              ? this.product_data.product_id
              : this.product_data.images[0].product_id,
          merchant_uuid:
            product_type == "simple"
              ? this.product_data.product_details.merchant_uuid
              : this.product_data.merchant_uuid,
        };
        await this.productDelete(param);
        this.$root.$emit("productDeletedFetchProductList");
        this.closeModal();
      }
    },
  },
  watch: {
    status: function (status) {
      if (status === true) {
        this.$refs.EditProduct.show();
        this.$store.commit("estoreInventories/setActiveImage", null);
        this.$store.commit("estoreInventories/errors", null);
      } else {
        this.$refs.EditProduct.hide();
      }
    },

    product_data: function (data) {
      this.$store.commit("estoreInventories/errors", null);

      // Simple Product
      if (!data.type) {
        let product_details = data.product_details;

        this.basic_details.name = product_details.name;
        this.basic_details.description = product_details.description;
        this.basic_details.product_variation = product_details.type;
        this.basic_details.category_id = product_details.category_id;

        product_details.images.map((image, index) => {
          this.product_images[index].image = image.image_name;
          this.product_images[index]["uuid"] = image.uuid;
        });
        this.ad_on_items = product_details.add_on_category;
      } else {
        // Variable Product
        this.basic_details.name = data.name;
        this.basic_details.description = data.description;
        this.basic_details.product_variation = data.type;
        this.basic_details.category_id = data.category_id;

        data.images.map((image, index) => {
          this.product_images[index].image = image.image_name;
          this.product_images[index]["uuid"] = image.uuid;
        });
        this.ad_on_items = data.add_on_category;
      }

      this.basic_details.branch_uuids = data.branch_uuids;
      this.basic_details.selected_all_brands_branches =
        data.selected_all_brands_branches;
      this.uuid = data.uuid;

      this.$store.commit("estoreInventories/setActiveImage", 0);

      if (!data.type) {
        this.simple_product.on_sale = data.on_sale == 1 ? true : false;
        this.simple_product.is_limited_stock =
          data.is_limited_stock == 1 ? true : false;
        this.simple_product.visibility = data.visibility == 1 ? true : false;
        this.simple_product.stock = data.stock;
        this.simple_product.currency = data.currency;
        this.simple_product.regular_price = Number.parseFloat(
          data.regular_price
        ).toFixed(2);
        this.simple_product.sku = data.sku;
      } else {
        this.product_variables.attributes = data.attributes.map((attribute) => {
          return {
            action: "update",
            name: attribute.name,
            product_id: attribute.product_id,
            uuid: attribute.uuid,
            variations: attribute.variations.map((variant) => {
              return {
                action: "update",
                hash: variant.hash,
                name: variant.name,
              };
            }),
          };
        });
        this.$parent.variation_items = data.inventory.map((product) => {
          let date_range = null;
          if (product.on_sale == 1) {
            date_range =
              product.on_sale_from.split(" ")[0] +
              " to " +
              product.on_sale_to.split(" ")[0];
          }

          if (!this.isUpdated) {
            this.old_variations.push({
              variation_code: product.variation_code,
              uuid: product.uuid,
            });
          }

          return {
            action: product.variation_code !== "" ? "update" : "create",
            variation: product.decoded_variation_code[0].value,
            variation_code: product.variation_code,
            stock: product.stock,
            is_limited_stock: product.is_limited_stock == 1 ? true : false,
            currency: product.currency,
            regular_price: Number.parseFloat(product.regular_price).toFixed(2),
            sku: product.sku,
            on_sale: product.on_sale,
            discount_type:
              product.on_sale == 1
                ? product.discount_type
                : this.product_variables.discount.discount_type,
            discount_value:
              product.on_sale == 1
                ? Number.parseFloat(product.discount_value).toFixed(2)
                : Number(
                    this.product_variables.discount.discount_value
                  ).toString(),
            on_sale_from:
              product.on_sale == 1 ? product.on_sale_from.split(" ")[0] : null,
            on_sale_to:
              product.on_sale == 1 ? product.on_sale_to.split(" ")[0] : null,
            visibility: product.visibility == 1 ? true : false,
            date_range: date_range,
            uuid: product.uuid,
          };
        });

        let variations = this.product_variables["attributes"].map((product) => {
          return product.variations;
        });

        let param_variations = [];

        for (let index = 0; index < variations.length; index++) {
          let attribute = this.product_variables["attributes"][index];
          this.product_variables["attributes"][index].variations =
            attribute.variations
              .map((variation) => {
                const timestamp = new Date().getUTCMilliseconds();
                let formattedVariations = {};
                formattedVariations["action"] = variation.action;
                formattedVariations["hash"] =
                  variation.name.slice(0, 4).toUpperCase() +
                  "-" +
                  index +
                  timestamp;
                formattedVariations["name"] = variation.name;
                return formattedVariations;
              })
              .filter((variation) => variation.name !== "");

          param_variations.push(
            attribute.variations.map((variation) => {
              return variation.name;
            })
          );
        }

        let combinations = pvg.combineArrays(param_variations);

        this.$parent.variation_names = combinations.map((variant) => {
          return {
            variation: variant.substring(1).replace(/_/g, " - ").trim(),
          };
        });
      }

      if (data.on_sale == 1) {
        this.simple_product.discount_type = data.discount_type;
        this.simple_product.discount_value = Number.parseFloat(
          data.discount_value
        ).toFixed(2);
      }

      if (!data.type) {
        if (data.product_details.images.length == 0) {
          this.$store.commit("estoreInventories/setActiveImage", null);
        } else {
          this.$store.commit("estoreInventories/setActiveImage", 0);
        }
        this.simple_product.date_range =
          data.date_range !== null && data.on_sale == 1
            ? data.on_sale_from.split(" ")[0] +
              " to " +
              data.on_sale_to.split(" ")[0]
            : this.$parent.formatDate(new Date()) +
              " to " +
              this.$parent.formatDate(new Date());
        this.init_daterange = [data.on_sale_from, data.on_sale_to];
      } else {
        if (data.images.length == 0) {
          this.$store.commit("estoreInventories/setActiveImage", null);
        } else {
          this.$store.commit("estoreInventories/setActiveImage", 0);
        }
      }

      this.isUpdated = true;
    },

    "modal.croppa.base64": function (base64) {
      if (base64 !== null) {
        let empty_images = this.product_images
          .map((image, index) => {
            return {
              image: image.image,
              index: index,
            };
          })
          .filter((image) => image.image == "");

        let get_index = empty_images[0].index;

        if (this.product_images[0] !== "") {
          this.$store.commit("estoreInventories/setActiveImage", 0);
        }

        this.product_images[get_index].image = base64;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-delete-product-container {
  bottom: -16px;
  background: #2f4858;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
}
</style>
